/** DB `lane_name` → セレクト表示（ユーザー合意の短い日本語寄りラベル） */
export const LANE_DISPLAY_LABEL: Record<string, string> = {
  'Exp Lane': 'EXP',
  'Mid Lane': 'ミッド',
  'Gold Lane': 'ゴールド',
  Jungle: 'ジャングル',
  Roam: 'ローム',
};

/** セレクトの並び（UI 用） */
export const LANE_FILTER_DB_ORDER = [
  'Exp Lane',
  'Mid Lane',
  'Gold Lane',
  'Jungle',
  'Roam',
] as const;
